export default "__VITE_PUBLIC_ASSET__5eab5595__"